import React ,{useEffect, useRef, useState, useLayoutEffect} from 'react'
import { TimeOffTypeItem } from './TimeOffTypeItem' 
import { TimeOffTypeForm } from './TimeOffTypeForm' 
import { useAppDispatch,useAppSelector } from '../../../app/hooks'
import { getAccountTimeOffTypeAsync,resetSelectedRecordObjectInState,DeleteSelectedAccountTimeOffTypeAsync,updatePagination } from './TimeOffTypeSlice' 
import TimeOffTypeOffCanvas from '../../../common/OffCanvas';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { getValueFromResource } from '../../../common/timeLiveFunction'
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

export const TimeOffType = () =>{

    
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { TimeOffTypeList, isReload,isLoading, selectedRecord, sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.timeOffType);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();



    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    // const filteredData: any = getFilteredList(TimeOffTypeList, searchTerm);
    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = TimeOffTypeList.length;
    // const recordsFiltered = filteredData.length;


    const filteredData: any = getFilteredList(TimeOffTypeList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = TimeOffTypeList.length;
    const recordsFiltered = filteredData.length;

    useEffect(() => {
        if (isReload) {
            dispatch(getAccountTimeOffTypeAsync());
        }

    }, [isReload])

    useEffect(() => {
        dispatch(getAccountTimeOffTypeAsync());
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setIsModalOpen(true);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountTimeOffTypeAsync(TimeOffTypeList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("TimeOff type deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }

    return (
        <>

{isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Time Off Type List')} */}
                        {getValueFromResource('Time Off Type List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {(IsAdd || (IsDelete && TimeOffTypeList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        } */}

                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}

                        {(IsAdd || (IsDelete && TimeOffTypeList.some((item: any) => item.isSelected === 1))) && (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        )}
                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: TimeOffTypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Time Off Type')} */}
                                {getValueFromResource('Add Time Off Type',dispatch, t)}

                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: TimeOffTypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{TimeOffTypeList.filter((item: any) => item.isSelected === 1).length}</span>
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected',dispatch, t)}

                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: TimeOffTypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <TimeOffTypeItem TimeOffTypeList={currentItems} modelRef={modelRef} t={t} onopenModal={openModal} oncloseModal={closeModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }
            </div>
            {isModalOpen &&
                <TimeOffTypeForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
        </>
    )
    // //const modelRef = useRef<any>(null);
    // const dispatch = useAppDispatch();
    // const {TimeOffTypeList,isReload,selectedRecord} = useAppSelector((state)=>state.timeOffType);

    // useEffect(()=>{
    //     if(isReload){
    //         dispatch(getAccountTimeOffTypeAsync());
    //     }
    // },[isReload]
    // )

    // useEffect(()=>{
    //     dispatch(getAccountTimeOffTypeAsync());
    // },[dispatch])
        
    // const handleOnClickEvent = ()=>{
    //     dispatch(resetSelectedRecordObjectInState());
    //     //modelRef.current.click();
    // }
    // const onDeleteSelectedClick = () => {
    //     ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
    //         .then((result) => {
    //             if (result) {
    //                 dispatch(DeleteSelectedAccountTimeOffTypeAsync(TimeOffTypeList))
    //                     .unwrap()
    //                     .then((originalPromiseResult) => {
    //                         originalPromiseResult[0].StatusCode === "200" ?
    //                         ShowToast("Time Off Type delete Successfully", 'Success', "success", "toast-top-right") :
    //                         ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
    //                     })
    //                     .catch((rejectedValueOrSerializedError) => {
    //                         ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //                     })
    //             }
    //         })
    //         .catch((error) => {
    //             console.log("ShowSwalWithConfirmation:error ", error);
    //         });

    // }
    // const generalObject = {
    //     "name": (Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add') + " Time Off Type",
    //     "width": "800px",
    //     "componentName": <TimeOffTypeForm />
    // }
    // return (
    //     <>
    //     <div className="card card-custom">
    //             <div className="card-header">
    //                 <h3 className="card-title">Time Off Type List</h3>
    //                 <div className="card-toolbar">
    //                     {/* <button ref={modelRef} type="button" className="btn btn-sm btn-primary" onClick={handleOnClickEvent}>
    //                         Add Time Off Type
    //                     </button> */}
    //                     <a id="kt_OffCanvas"
    //                         className='btn btn-sm btn-light-primary'
    //                         style={{ marginRight: '2px', display: TimeOffTypeList.every((item: any) => item.isSelected === 0) ? 'none' : 'none' }}
    //                         onClick={handleOnClickEvent}>
    //                         <KTIcon iconName='exit-up' className='fs-3' />{`Export`}
    //                     </a>
    //                     <a id="kt_OffCanvas"
    //                         className='btn btn-sm btn-light-primary'
    //                         style={{ marginRight: '2px', display: TimeOffTypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
    //                         onClick={handleOnClickEvent}>
    //                         <KTIcon iconName='plus' className='fs-3' />{`Add Time Off Type`}
    //                     </a>
    //                     <div className="fw-bold me-5" style={{ marginRight: '2px', display: TimeOffTypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
    //                         <span className="me-2" data-kt-user-table-select="selected_count">{TimeOffTypeList.filter((item: any) => item.isSelected === 1).length}</span> Selected
    //                     </div>
    //                     <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
    //                         style={{ marginRight: '2px', display: TimeOffTypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
    //                     >
    //                         Delete Selected
    //                     </button>
    //                 </div>
    //             </div>
    //             <div className="card-body">
    
    //                 <div className="table-responsive">
    //                     <TimeOffTypeItem TimeOffTypeList={TimeOffTypeList} />
    //                     {/* <table className="table table-striped gy-7 gs-7">
    //                         <thead>
    //                             <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
    //                                 <th></th>
    //                                 <th>Time Off Type</th>
    //                                 <th>Request Required</th>
    //                                 <th></th>
    //                             </tr>
    //                         </thead>
    //                         <tbody>
                                
    //                             {TimeOffTypeList.length === 0 && <tr><td>No Record Found.</td></tr>}
    //                             {TimeOffTypeList.length > 0 && TimeOffTypeList.map((timeOffType, i) => {
    //                                 return <TimeOffTypeItem timeOffTypeDetail={timeOffType} key={i} modelRef={modelRef} />
    //                             })}
    //                         </tbody>
    //                     </table> */}
    //                 </div>
    //             </div>
    //         </div>
    //         <TimeOffTypeOffCanvas obj={generalObject}  />
    //          {/* <TimeOffTypeForm modelRef={modelRef} />
    //          <button ref={modelRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#timeOffTypeModal">
    //              Launch demo modal
    //          </button> */}
    //          </>
    // )
}